module.exports = __webpack_public_path__ + "static/img/tx011.587d124.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/qualifications/tx011.png
// module id = CHYL
// module chunks = 1